import { Abonnement } from "@happy-legal/graphql-types";

// Do not query hasValidAbo to avoid unnecessary Stripe/PayPal calls
export const isAboValid = (abo: Abonnement) => !!abo && !abo?.locked;
